import { atomWithStorage } from 'jotai/utils';

export const contrastModeAtom = atomWithStorage('contrastMode', false);
